import type { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import type { Data, Logger, RefSchemas, Structure } from '@wix/thunderbolt-becky-types'
import * as byref from '@wix/thunderbolt-byref'

export const resolveCommonAspects = (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload,
	schemas: RefSchemas,
	logger?: Logger
) =>
	functionLibrary.runAsyncAndReport(async () => {
		const resolveGhosts = requestPayload.resolveGhosts === 'true'

		const fetchRemoteRefs = functionLibrary.runAndReport(
			() =>
				byref.createRemoteRefsFetcher(
					functionLibrary.fetchUrl.bind(functionLibrary),
					beckyModel.clientSpecMap,
					beckyModel.publicTopology,
					requestPayload,
					undefined,
					undefined,
					Boolean(beckyModel.experiments['specs.thunderbolt.fetch_widget_iteratively']),
					Boolean(beckyModel.experiments['specs.thunderbolt.fetchBlocksDevCenterWidgetIds']),
					Boolean(beckyModel.experiments['specs.thunderbolt.migrateStylableComponentsInBlocksWidgets']),
					Boolean(beckyModel.experiments['specs.thunderbolt.BuilderComponent']),
					Boolean(beckyModel.experiments['specs.thunderbolt.SetNoCacheOnRefComponentError']),
					logger
				),
			'createRemoteRefsFetcher'
		)

		const model = {
			...beckyModel,
			...(beckyModel.pageCompId === 'masterPage' && { structure: masterPageStructure, data: masterPageData }),
			masterPageStructure,
			masterPageData,
			requestPayload,
			resolveGhosts,
		}

		const widgetTemplatesStore = await functionLibrary.runAsyncAndReport(
			() => fetchRemoteRefs(model.data.document_data),
			'fetchRemoteRefs'
		)

		const res = functionLibrary.runAndReport(
			() => byref.resolveCommonAspects({ ...model, widgetTemplatesStore }, schemas, functionLibrary.runAndReport),
			'resolveCommonAspects'
		)

		return { ...model, ...res }
	}, 'tb-byRef-resolving')
